import React from "react";
import Plot from "react-plotly.js";

function Component({
  plotData,
  title,
  yaxis,
}: {
  plotData: any;
  title: string;
  yaxis: string;
}) {
  return (
    // <div className="Chart">
    <Plot
      className="fullsize"
      data={plotData}
      layout={{
        autosize: true,
        title: { text: title },
        yaxis: { title: { text: yaxis } },
      }}
      useResizeHandler
    />
    // </div>
  );
}

export default Component;
